import React, { useEffect, useState } from 'react';
import './attachment-files.scss';
import uploadIcon from 'assests/svg/upload_icon.svg';
import viewIcon from 'assests/svg/eye.svg';
import { isTypeOfImage, dataURItoBlob } from 'home/view/upgrade-order/utils';
import FileSaver from 'file-saver';

const attachmentFiles = ({ supportedTypes = 'application/pdf,image/jpeg,image/jpg,image/png', noOfFiles = 5, onFileUploaded, disabled }) => {
  const defaultPdfImage = `https://pbs.twimg.com/media/FBKSGxMVEAIkEY7?format=jpg&name=large`;
  const [filesInfo, setFilesInfo] = useState([
    {
      isUploaded: false,
      fileUrl: '',
      error: null,
      file: null,
      src: ''
    }
  ]);

  useEffect(() => {
    const filesList = [];
    for (let i = 0; i < noOfFiles; i++) {
      filesList.push({
        isUploaded: false,
        type: '',
        src: '',
        content: '',
        error: null
      });
    }
    setFilesInfo(filesList);
  }, []);

  const onFileUpload = ({ target: { files: uploadedFiles } }, index) => {
    const [file] = uploadedFiles;
    previewFile(file, index, setStateForFileInfo);
  };

  const setStateForFileInfo = (index, file, readerResult) => {
    let newState = [...filesInfo];
    newState[index].isUploaded = true;
    newState[index].type = file.type;
    newState[index].file = file;
    newState[index].content = readerResult;
    newState[index].src = isTypeOfImage(file) ? readerResult : defaultPdfImage;

    setFilesInfo([...newState]);
  };

  const onPreviewClick = (data, type) => {
    const file = dataURItoBlob(data);
    FileSaver.saveAs(file);
  };

  const getUploadedElement = (src, content, type, index) => {
    return (
      <li key={`file ${index}`} className="uploaded_files" onClick={onPreviewClick.bind(null, content, type)}>
        <img className="file_img" src={src} alt="Uploaded" />
        <img className="view_icon" src={viewIcon} alt="Uplaod" />
      </li>
    );
  };

  const previewFile = (file, index, callBack) => {
    let reader = new FileReader();
    reader.onloadend = function () {
      callBack && callBack(index, file, reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    }
  };
  const getFileElements = (files) => {
    if (Array.isArray(files)) {
      return files.map(({ isUploaded, content, src, type, error }, index) => {
        return isUploaded ? (
          getUploadedElement(src, content, type, index)
        ) : (
          <li key={`file ${index}`}>
            <img className="upload_icon" src={uploadIcon} alt="Uplaod" />
            <input className="file_upload" type="file" accept={supportedTypes} onChange={(event) => onFileUpload(event, index)} disabled={disabled} />
          </li>
        );
      });
    }
    return [];
  };

  useEffect(() => {
    onFileUploaded && onFileUploaded(filesInfo);
  }, [filesInfo]);

  return (
    <div className="attachment_area">
      <div className="attach_title">Attachments up to 5 files</div>
      <div className="file_info">Supported file formats are .JPG, .PNG, .PDF • Maximum file size is 2 Mb</div>
      <ul className="file_items" style={{ display: 'flex' }}>
        {getFileElements(filesInfo)}
      </ul>
    </div>
  );
};

export default attachmentFiles;
